var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5C11.8137 14.5 14.5 11.8137 14.5 8.5C14.5 5.18629 11.8137 2.5 8.5 2.5C5.18629 2.5 2.5 5.18629 2.5 8.5C2.5 11.8137 5.18629 14.5 8.5 14.5Z",
    fill: "#94C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13512 11.9736L8.50012 14.4999H3.41887C2.75012 14.4999 2.41637 13.6924 2.88887 13.2199L4.13512 11.9736Z",
    fill: "#94C6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85249 9.20645C6.24254 9.20645 6.55874 8.89025 6.55874 8.5002C6.55874 8.11014 6.24254 7.79395 5.85249 7.79395C5.46244 7.79395 5.14624 8.11014 5.14624 8.5002C5.14624 8.89025 5.46244 9.20645 5.85249 9.20645Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49971 9.20645C8.88976 9.20645 9.20596 8.89025 9.20596 8.5002C9.20596 8.11014 8.88976 7.79395 8.49971 7.79395C8.10966 7.79395 7.79346 8.11014 7.79346 8.5002C7.79346 8.89025 8.10966 9.20645 8.49971 9.20645Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1472 9.20645C11.5372 9.20645 11.8534 8.89025 11.8534 8.5002C11.8534 8.11014 11.5372 7.79395 11.1472 7.79395C10.7571 7.79395 10.4409 8.11014 10.4409 8.5002C10.4409 8.89025 10.7571 9.20645 11.1472 9.20645Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 21.5C18.2541 21.5 21.5 18.2541 21.5 14.25C21.5 10.2459 18.2541 7 14.25 7C10.2459 7 7 10.2459 7 14.25C7 18.2541 10.2459 21.5 14.25 21.5Z",
    fill: "#3987F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5248 18.4478L14.2498 21.5003H20.1635C21.0548 21.5003 21.501 20.4228 20.871 19.7928L19.526 18.4478H19.5248Z",
    fill: "#3987F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4489 15.1025C17.9198 15.1025 18.3014 14.7208 18.3014 14.25C18.3014 13.7791 17.9198 13.3975 17.4489 13.3975C16.9781 13.3975 16.5964 13.7791 16.5964 14.25C16.5964 14.7208 16.9781 15.1025 17.4489 15.1025Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2504 15.1025C14.7213 15.1025 15.1029 14.7208 15.1029 14.25C15.1029 13.7791 14.7213 13.3975 14.2504 13.3975C13.7796 13.3975 13.3979 13.7791 13.3979 14.25C13.3979 14.7208 13.7796 15.1025 14.2504 15.1025Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0515 15.1025C11.5223 15.1025 11.904 14.7208 11.904 14.25C11.904 13.7791 11.5223 13.3975 11.0515 13.3975C10.5807 13.3975 10.199 13.7791 10.199 14.25C10.199 14.7208 10.5807 15.1025 11.0515 15.1025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatBlue);
export default __webpack_public_path__ + "static/media/icon_chat_blue.eae9df3f.svg";
export { ForwardRef as ReactComponent };